import { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import api from '../lib/api.js';
import { setKey, setUser } from '../lib/auth.jsx';

export default function AcceptInvite() {
  const [search] = useSearchParams();
  const token = search.get('token') || '';
  const email = search.get('email') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [agree, setAgree] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault(); setErr('');
    if (!agree) { setErr('Please accept the Terms to finish creating your account.'); return; }
    if (password !== confirm) { setErr('Passwords do not match.'); return; }
    if (password.length < 8) { setErr('Password must be at least 8 characters.'); return; }
    setBusy(true);
    try {
      const r = await api.acceptInvite({ token, email, password });
      if (r?.access_key) setKey(r.access_key);
      if (r?.user) setUser(r.user);
      nav('/dashboard', { replace: true });
    } catch (e) {
      setErr(e?.data?.detail || e?.data?.error || e.message || 'Could not accept invite');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-navy via-navy-700 to-navy-800 flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white rounded-xl shadow-2xl p-8">
        <Link to="/" className="block mb-6 text-center"><span className="font-bold text-navy">MAPTRIUM™</span></Link>
        <h1 className="text-2xl font-bold text-navy mb-2">Welcome — finish setting up</h1>
        <p className="text-sm text-ink-muted mb-4">Account: <strong>{email || '(missing email)'}</strong>. Pick a password to use going forward.</p>
        <div className="mb-4 bg-amber-50 border border-amber-300 rounded p-3 text-xs text-amber-900">
          <strong>Before continuing, please agree:</strong>
          <ul className="mt-1 ml-4 list-disc space-y-1">
            <li>Billing is in advance and <strong>non-refundable</strong>.</li>
            <li>You are responsible for the accuracy of any data you upload. Final QA is the <strong>client's sole responsibility</strong>.</li>
          </ul>
          <Link to="/terms" target="_blank" className="font-semibold underline mt-2 block">Read the full Terms ↗</Link>
          <label className="flex items-start gap-2 mt-2">
            <input type="checkbox" checked={agree} onChange={e => setAgree(e.target.checked)} className="mt-0.5" />
            <span>I have read and agree.</span>
          </label>
        </div>
        {!token || !email ? (
          <div className="text-sm text-red-600">This invite link is missing required parameters. Ask your administrator to resend it.</div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <input type="password" required minLength={8} placeholder="Choose a password (8+ chars)"
              className="input" value={password} onChange={e => setPassword(e.target.value)} />
            <input type="password" required minLength={8} placeholder="Confirm password"
              className="input" value={confirm} onChange={e => setConfirm(e.target.value)} />
            {err && <div className="text-sm text-red-600">{err}</div>}
            <button className="btn btn-primary w-full" disabled={busy || !agree || !password || !confirm}>
              {busy ? 'Activating…' : 'Activate account & sign in'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
